import { defineStore } from 'pinia';
// eslint-disable-next-line max-len
import {
  DocumentModerationFilterStatusListItem,
  DocumentModerationFilterStatusListValueProperty,
} from '@/models/dictionary/document-moderation-filter-status-list.model';
import { showErrorNotification } from '@/utils/show-notification.util';
import { api } from '@/services/http.service';

interface DocumentModerationFilterStatusListState {
  documentModerationFilterStatusList: DocumentModerationFilterStatusListItem[];
  isDocumentModerationFilterStatusListLoading: boolean;
}

export const useDocumentModerationFilterStatusListStore = defineStore('DocumentModerationFilterStatusListStore', {
  state: (): DocumentModerationFilterStatusListState => ({
    documentModerationFilterStatusList: [],
    isDocumentModerationFilterStatusListLoading: false,
  }),
  getters: {
    excludeAllDocumentModerationFilterStatusList(
      state: DocumentModerationFilterStatusListState,
    ): DocumentModerationFilterStatusListItem[] {
      return state.documentModerationFilterStatusList
        .filter(({ value }: DocumentModerationFilterStatusListItem) =>
          value !== DocumentModerationFilterStatusListValueProperty.ALL);
    },
  },
  actions: {
    setDocumentModerationFilterStatusListLoading(isLoading: boolean): void {
      this.isDocumentModerationFilterStatusListLoading = isLoading;
    },
    getDocumentModerationFilterStatusList(whitelabelSlug: string): Promise<DocumentModerationFilterStatusListItem[]> {
      if (this.documentModerationFilterStatusList.length) {
        return Promise.resolve(this.documentModerationFilterStatusList);
      }

      return api.dictionary.getDocumentModerationFilterStatusListRequest.perform(whitelabelSlug)
        .then((data: DocumentModerationFilterStatusListItem[]) => {
          this.documentModerationFilterStatusList = data;

          return data;
        })
        .catch((error) => {
          showErrorNotification(error);

          return [];
        })
        .finally(() => {
          this.setDocumentModerationFilterStatusListLoading(false);
        });
    },
  },
});
